import { render } from "./RodasepProductos.vue?vue&type=template&id=5f05e4b6&scoped=true"
import script from "./RodasepProductos.vue?vue&type=script&lang=js"
export * from "./RodasepProductos.vue?vue&type=script&lang=js"

import "./RodasepProductos.vue?vue&type=style&index=0&id=5f05e4b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f05e4b6"]])

export default __exports__